// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"f2ae91fa","724":"aa5605cc"}[chunkId] + ".chunk.css";
};